<app-modal-template title="Delete Survey" [disabled]="isDeleting">
    <div class="modal-body-content mb-3">
      <div class="loadingDiv" *ngIf="isDeleting">
        <div class="loader"></div>
      </div>
      <div>
        <label>The following will be deleted.</label>
      </div>
      <table class="studyModalTable" data-page-length="5">
        <thead>
          <tr>
            <th>Survey Versions</th>
          </tr>
        </thead>
        <tbody>
          <tr class="studies" *ngFor="let item of surveyKeys">
            <td>
              {{ item.surveyVersionName }}
            </td>           
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer-content">
      <div class="d-flex">
        <button mat-button class="btn btn-secondary" [disabled]="isButtonDisabled"
          (click)="onCloseModal()">Cancel</button>
        <button type="submit" class="btn btn-primary ml-auto" [disabled]="isButtonDisabled"
          (click)="deleteConfirmation()">Delete</button>
      </div>
    </div>
  </app-modal-template>